<app-public-page [pageCaption]="login_welkomtekst">
  <form class="login-form">

    <input #inputName  type="text" [placeholder]="audio.text.login.username.toUpperCase() + '*'"
      name="username" required [(ngModel)]="user.username">
    <input  type="password"
      [placeholder]="audio.text.login.password.toUpperCase() +'*'" name="password" required [(ngModel)]="user.password">

    <div class="button-row">
      <app-button (click)="login()" [disabled]="loading">{{audio.text.login.login}}</app-button>

      <div class="x-text-link small forgotpassword" (click)="forgotPassword(); audio.playSoundClick();">
        <span>{{audio.text.login.forgetPassword}}?</span>
      </div>
    </div>

    <div class="notes">
      <span class="error subnote" *ngIf="passwordMessage">{{passwordMessage}}</span>
      <span class="error subnote" *ngIf="errorMessage" [innerHTML]="errorMessage"></span>
    </div>

    <app-line></app-line>

    <div class="subscribe-box">
      <div class="x-caption"><span>{{audio.text.login.benjenieuwhier}}</span></div>

      <app-button (click)="register(); audio.playSoundClick();">
        {{audio.text.login.inschrijven}}
      </app-button>
    </div>
    <br>

    <div style="position: fixed; bottom:3.75em; right: 1em;">
      <a href="{{otherLanguage.link}}" class="button raised yellow">
        <span class="button_text">{{otherLanguage.caption}}</span>
      </a>
    </div>

    <div class="colofon-box" (click)="colofon(); audio.playSoundClick();">{{audio.text.login.colofon}}</div>
  </form>


</app-public-page>
<section class="" *ngIf="showColofon" >
  <app-responsive-popup  [caption]="audio.text.login.colofon" [headerDecoration]="true">
      <div class="colofon-content">
        <app-button (click)="DownloadManual()">{{audio.text.login.manualDownload}}</app-button>
        <div [innerHTML]="colofonText" class="colofon-area"></div>
        <br>
        <app-button (click)="colofon(); audio.playSoundClick();">{{audio.text.login.klaar}}</app-button>
      </div>
  </app-responsive-popup>
</section>
